// extracted by mini-css-extract-plugin
export default {"title":"ConnectionPage_title__2D8O3","tag":"ConnectionPage_tag__e+gJ5","breadcrumb":"ConnectionPage_breadcrumb__WWpur","otherActions":"ConnectionPage_otherActions__t1s6B"};